module.exports = __webpack_public_path__ + "img/in_progress.eb72661b.svg";